import { render, staticRenderFns } from "./ViewAwardee.vue?vue&type=template&id=8a92358c&scoped=true&"
import script from "./ViewAwardee.vue?vue&type=script&lang=js&"
export * from "./ViewAwardee.vue?vue&type=script&lang=js&"
import style0 from "./ViewAwardee.vue?vue&type=style&index=0&id=8a92358c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a92358c",
  null
  
)

component.options.__file = "ViewAwardee.vue"
export default component.exports